<template>
  <div>
    <div class="bcNumber">
      <div class="bcNumber2"></div>
      <span class="one">智能改变生活</span>
      <div class="xian"></div>
      <span class="two">专注提供一站式智能化解决方案</span>
      <div class="bottom"></div>
      <div class="z-bottom">
        <div class="all">
          <ul>
            <li>
              <div class="topContent">
                <span class="number">{{ industryYears }}</span>
                <span class="company">年</span>
              </div>
              <div class="bottomCenter">
                <span class="content">行业经验</span>
              </div>
              <div class="Clivages"></div>
            </li>
            <li>
              <div class="topContent">
                <span class="number">40</span>
                <span class="company">+</span>
              </div>
              <div class="bottomCenter">
                <span class="content">城市覆盖</span>
              </div>
              <div class="Clivages"></div>
            </li>
            <li>
              <div class="topContent">
                <span class="number">60</span>
                <span class="company">+</span>
              </div>
              <div class="bottomCenter">
                <span class="content">战略伙伴</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="about">
      <div class="smart">SMART</div>
      <div class="ce">关于昌恩智能</div>
      <!-- ???如何在结尾文字最后一行居中 -->
      <p>
        公司成立于1998年5月22日,是经广东省公安厅、广东省住建厅批准认证、在建设“智慧城市”背景下为客户提供智能化整体解决方案的综合性企业。公司目前以建筑智能化、智能交通为主营业务。
      </p>
    </div>
    <div class="yi"></div>

    <!-- 四个图标 -->
    <div class="fourImg">
      <ul>
        <li>
          <router-link :to="{ path: '/introduction' }">
            <img src="../assets/img/icon-集团介绍_mob.png" alt="" />
            <span>集团介绍</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ path: '/project', query: { id: 0 } }">
            <img src="../assets/img/icon-案例展示_mob.png" alt="" />
            <span>案例展示</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ path: '/qualification' }">
            <img src="../assets/img/icon-资质中心_mob.png" alt="" />
            <span>资质中心</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ path: '/ceo' }">
            <img src="../assets/img/icon-董事长致辞_mob.png" alt="" />
            <span>董事长致辞</span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 公司业务 -->
    <div class="business">
      <!-- 背景opacity后 文字也会虚化  分开放 -->
      <div class="Intellectualization"></div>
      <span class="IntellectualizationSpan">城市与建筑智能化</span>
      <div class="wisdomTraffic"></div>
      <span class="wisdomtrafficSpan">智能交通</span>
      <div class="title">
        <span>主营业务</span>
      </div>
      <div class="dottedLine"></div>
      <div class="introduce">
        <div class="briefly">
          城市与建筑智能化服务领域遍及政府机构、金融行业、教
          育、医疗、公安边防、文博系统、旅游景点等。
        </div>
        <div class="more">
          <router-link :to="{ path: '/architecture' }">
            <span>加载更多</span>
            <img src="../assets/img/icon_more.svg" />
          </router-link>
        </div>
      </div>

      <div class="traffic"></div>

      <div class="introduce2">
        <div class="briefly2">
          智能交通业务涉及出租车、网约车、两客一危及车辆运营监 管平台与终端等。
        </div>
        <div class="more">
          <router-link :to="{ path: '/architecture2' }">
            <span>加载更多</span>
            <img src="../assets/img/icon_more.svg" />
          </router-link>
        </div>
      </div>
    </div>

    <!-- 新闻中心 
        100.5+40
    -->
    <div class="news">
      <div class="newsbg">NEWS</div>
      <div class="newCenter">
        <!-- 100 247 + 26.5 -->
        <span>新闻中心</span>
      </div>

      <div class="fourTitle">
        <ul>
          <li
            class="change"
            :class="currentIndex == index ? 'active' : ''"
            v-for="(item, index) in list"
            :key="item.id"
            @click="change(index)"
          >
            <button @click="select2(`${item.gopath}`, index)">
              {{ item.title }}<i></i>
            </button>
          </li>
          <li
            v-if="!list.id"
            style="width: 100vw; text-align: center; padding: 10vw 0"
          >
            暂无数据
          </li>
          <!-- <li><button @click="select1()">最新消息</button></li>
                <li><button @click="select2('集团公告')">集团公告 <i></i></button></li>
                <li><button @click="select2('信息披露')">信息披露</button></li>
                <li><button @click="select2('公司动态')">公司动态</button></li> -->
        </ul>
      </div>

      <div class="shownews">
        <div class="newsab"></div>
        <ul>
          <li v-for="(person, index) in arr" :key="index">
            <router-link
              :to="{
                path: `/newdetailed/${encodeURIComponent($route.fullPath)}`,
                query: {
                  id: `${person.resourceId}`,
                  newsTime: `${person.createTime}`
                }
              }"
            >
              <div class="left">
                <h3>{{ person.createTime.slice(8, 10) }}</h3>
                <span class="yearMonth">{{
                  person.createTime.slice(0, 7)
                }}</span>
                <i></i>
              </div>

              <div class="right">
                <span class="newTitle">{{ person.title }}</span>
                <span class="newContent">{{ person.limitContent }}......</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import axios from 'axios'
export default {
  name: 'index',
  data () {
    return {
      status: 1,
      type: 1,
      arr: [],
      regex: /(<([^>]+)>)/gi,
      currentIndex: 0, //表示当前选项卡,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: '最新消息', //标题
          gopath: ''
        },
        {
          id: 2,
          title: '集团公告', //标题
          gopath: '集团公告'
        },
        // {
        //   id: 3,
        //   title: "信息披露", //标题
        //   gopath: "信息披露"
        // },
        {
          id: 4,
          title: '公司动态', //标题
          gopath: '公司动态'
        }
      ],
      industryYears: null
    }
  },

  mounted () {
    // this.select();
    setTimeout(() => {
      this.select()
    }, 500)

    this.change(this.currentIndex)

    const currentYear = new Date().getFullYear()
    this.industryYears = currentYear - 1998
  },
  methods: {
    change (index) {
      console.log(index)
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index
    },

    async select () {
      try {
        const res = await this.request.get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4
          }
        })
        this.arr = res.data.data
        console.log('news', this.arr)
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].limitContent = this.getSimpleText(
            this.arr[i].limitContent
          )
        }
        console.log('component')
      } catch (error) {
        console.error(error)
      }
    },

    select1 () {
      this.arr = []
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4
          }
        })
        .then(res => {
          this.arr = res.data.data
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].limitContent = this.getSimpleText(
              this.arr[i].limitContent
            )
          }
        })
    },
    select2 (type, index) {
      this.arr = []
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4,
            category: type
          }
        })
        .then(res => {
          this.arr = res.data.data
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].limitContent = this.getSimpleText(
              this.arr[i].limitContent
            )
          }
        })
    },
    getSimpleText (html) {
      const re1 = new RegExp('<.+?>', 'g') // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: '<',
        gt: '>',
        nbsp: ' ',
        amp: '&',
        quot: '"',
        ldquo: '“',
        mdash: '—',
        rdquo: '”'
      }
      return html
        .replace(re1, '')
        .replace(
          /&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi,
          function (all, t) {
            return arrEntities[t]
          }
        )
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 728px) and (min-width: 799px) {
  .fourImg ul li span {
    font-size: 3.2vw !important;
  }
}
button {
  border: none;
  background-color: transparent;
  outline: none;
}
.yi {
  width: 92vw;
  height: 0.1333vw;
  background-color: #e8ebec;
  margin-top: 10.6667vw;
  margin: 10.6667vw auto 0px;
}
.bcNumber {
  position: relative;
  /* background-image: url(../assets/img/homepage_banner_mob.png); */
  background-image: url(../assets/img/homepage_banner_mob.png);
  background-size: 100% 100%;
  width: 100vw;
  height: 117.3333vw;
  background-size: cover;
  background-position: 60%;
}
.bcNumber2 {
  width: 100%;
  height: 100%;
  background-color: red;
  background-color: rgba(0, 0, 0, 0.4);
}
.bcNumber .one {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 25.8667vw;
  letter-spacing: 1.3333vw;
  line-height: 13.8667vw;
  font-size: 8.5333vw;
  color: #ffffff;
  font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
  font-weight: normal;
  white-space: nowrap;
}
.bcNumber .xian {
  width: 97.3333vw;
  /* height: 0.2667vw; */
  border: 0.2667vw solid;
  /* padding: 46.6667vw 2vw 0vw 2vw; */
  margin: -70.6667vw auto;
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    3 3;
}
.bcNumber .two {
  position: absolute;
  width: 85.8667vw;
  font-size: 3.2vw;
  top: 57.3333vw;
  right: 7.0667vw;
  left: 7.0667vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  letter-spacing: 2.9333vw;
  opacity: 0.88;
  white-space: nowrap;
}
.bcNumber .bottom {
  position: absolute;
  width: 100%;
  height: 24vw;
  bottom: 0vw;
  background: #ffffff;
  opacity: 0.19;
  z-index: 1;
}
.bcNumber .z-bottom {
  position: absolute;
  width: 100%;
  height: 24vw;
  bottom: 0vw;
  z-index: 2;
}
.bcNumber .z-bottom .all {
  width: 84vw;
  height: 100%;
  margin: 0 auto;
}
.bcNumber .z-bottom ul {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
}
.bcNumber .z-bottom ul li {
  float: left;
  position: relative;
  display: inline-block;
  width: 24vw;
  border: 100%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
}
.bcNumber .z-bottom ul li:nth-child(2) {
  float: left;
  position: relative;
  display: inline-block;
  width: 36vw;
  border: 100%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
}
.bcNumber .z-bottom ul li:nth-child(2) .topContent {
  left: 12vw;
}
.bcNumber .z-bottom ul li:nth-child(2) .bottomCenter {
  left: 12vw;
  opacity: 0.81;
}
.bcNumber .z-bottom ul li:nth-child(3) .topContent {
  right: 0px;
}
.bcNumber .z-bottom ul li:nth-child(3) .bottomCenter {
  right: 0px;
  opacity: 0.81;
}
.bcNumber .z-bottom ul li .topContent {
  position: absolute;
  top: 5.8667vw;
}
.bcNumber .z-bottom ul li .topContent .number {
  font-size: 6.6667vw;
  letter-spacing: 0.2667vw;
  line-height: 7.7333vw;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #ffb100;
  text-shadow: 0vw 0.1333vw 0.1333vw rgba(0, 0, 0, 0.5);
}

.bcNumber .z-bottom ul li .topContent .company {
  margin-bottom: 1.3333vw;
  font-size: 3.4667vw;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ffffff;
  letter-spacing: 0.2667vw;
}
.bcNumber .z-bottom ul li .bottomCenter {
  margin-top: 13.6vw;
  position: absolute;
  opacity: 0.81;
}

.bcNumber .z-bottom ul li .bottomCenter .content {
  font-size: 2.6667vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 3.7333vw;
  letter-spacing: 0.2667vw;
}
.bcNumber .z-bottom ul li .Clivages {
  position: absolute;
  float: left;
  height: 12.8vw;
  width: 0.2667vw;
  right: 0px;
  background-color: #54606e;
  top: 5.8667vw;
}
.about {
  position: relative;
}

.about .smart {
  position: absolute;
  top: 7.8667vw;
  left: 10.5333vw;
  font-size: 21.3333vw;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  color: #fafafa;
  letter-spacing: 1.0667vw;
  z-index: -1;
}

.about .ce {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  padding-top: 16.6667vw;
  height: 29.3333vw;
  font-size: 6.4vw;
  /* font-family: FZZCHJW--GB1-0, FZZCHJW--GB1; */
  font-weight: normal;
  color: #140047;
  line-height: 8vw;
  letter-spacing: 1.8293vw;
  font-family: AlibabaPuHuiTiB;
}
.about p {
  display: block;
  margin: 0 auto;
  padding-top: 28vw;
  width: 89.3333vw;
  text-align: center;
  font-size: 3.2vw;
  letter-spacing: 0.1333vw;
  line-height: 5.3333vw;
}
.fourImg {
  height: 90.6667vw;
  width: 78.9933vw;
  margin: 10.6667vw 10.5333vw 10.6667vw 10.5333vw;
}

.fourImg ul li {
  position: relative;
  display: inline-block;
  float: left;
  background-image: url(../assets/img/six.png);
  width: 35.4667vw;
  height: 41.3333vw;
  background-size: 100% 100%;
}
/* .fourImg ul li:before{
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    width: 35.4667vw;
    height: 11.8vw;
    transform: rotate(60deg);
    background-color: #F7F9FC;
}

.fourImg ul li:after{
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    width: 35.4667vw;
    height: 11.8vw;
    transform: rotate(120deg);
    background-color: #F7F9FC;
} */

.fourImg ul li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fourImg ul li span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.fourImg ul > li:nth-child(1) {
  margin-right: 8vw;
}
.fourImg ul > li:nth-child(1) img {
  width: 11.2vw;
  height: 8vw;
  margin: 13.0667vw 12.1333vw 0vw 12.1333vw;
  /* border: 0.2667vw dashed #d6d6d6; */
}
.fourImg ul > li:nth-child(1) span {
  font-size: 3.2vw;
  letter-spacing: 0.32vw;
  color: #16171b;
  /* 这里设置行号会跑出li  */
  /* line-height: 16.5; */
  margin: 2.6667vw 10.6667vw 0vw 10.6667vw;
  white-space: nowrap;
}
.fourImg ul > li:nth-child(2) {
}
.fourImg ul > li:nth-child(2) img {
  width: 11.2vw;
  height: 6.2667vw;
  margin: 13.7333vw 12vw 0vw 12.2667vw;
  /* border: 0.2667vw dashed #d6d6d6; */
}
.fourImg ul > li:nth-child(2) span {
  font-size: 3.2vw;
  letter-spacing: 0.32vw;
  color: #16171b;
  /* 这里设置行号会跑出li  */
  /* line-height: 16.5; */
  margin: 4vw 10.6667vw 0vw 10.6667vw;
  white-space: nowrap;
}
.fourImg ul > li:nth-child(3) {
  margin-top: 8vw;
  margin-right: 8vw;
}
.fourImg ul > li:nth-child(3) img {
  width: 9.6vw;
  height: 8.1333vw;
  margin: 13.3333vw 12.6667vw 0vw 13.2vw;
  /* border: 0.2667vw dashed #d6d6d6; */
}
.fourImg ul > li:nth-child(3) span {
  font-size: 3.2vw;
  letter-spacing: 0.32vw;
  color: #16171b;
  /* 这里设置行号会跑出li  */
  /* line-height: 16.5; */
  margin: 2.5333vw 10.6667vw 0vw 10.6667vw;
  white-space: nowrap;
}
.fourImg ul > li:nth-child(4) {
  margin-top: 8vw;
}
.fourImg ul > li:nth-child(4) img {
  width: 10.5333vw;
  height: 8vw;
  margin: 13.3333vw 12.4vw 0vw 12.5333vw;
  /* border: 0.2667vw dashed #d6d6d6; */
}
.fourImg ul > li:nth-child(4) span {
  font-size: 3.2vw;
  letter-spacing: 0.32vw;
  color: #16171b;
  /* 这里设置行号会跑出li  */
  /* line-height: 16.5; */
  margin: 2.5333vw 8.9333vw 12.9333vw 8.9333vw;
  white-space: nowrap;
}

.business {
  position: relative;
  height: 308vw;
  margin-top: 10.6667vw;
  background-color: #f1f4fb;
}

.business .title {
  position: absolute;
  top: 8vw;
  width: 47.3333vw;
  height: 27.2vw;
  opacity: 0.8;
  background-color: #ffffff;
}
.business .title span {
  position: absolute;
  display: inline-block;
  width: 29.4667vw;
  top: 6.6667vw;
  right: 7.0667vw;
  left: 10.8vw;
  font-size: 6.4vw;
  font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
  font-weight: normal;
  color: #140047;
  font-weight: 600;
}
.business .Intellectualization {
  position: absolute;
  top: 34.6667vw;
  right: 5.2vw;
  width: 30.1333vw;
  padding: 0 7vw;
  height: 7.7333vw;
  /* background-color: #3b5e7f; */
  background-color: #01060a;
  box-shadow: 0vw 0.1333vw 1.3333vw 0vw rgba(206, 206, 206, 0.9);
  opacity: 0.42;
  z-index: 3;
  /* right: 5.3vw; */
  right: 5.5vw;
}
.business .IntellectualizationSpan {
  position: absolute;
  display: block;
  top: 35.4667vw;
  right: 8.9333vw;
  letter-spacing: 0.248vw;
  font-size: 4.2667vw;
  height: 7.7333vw;
  line-height: 6.1333vw;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ffffff;
  opacity: 1;
  z-index: 4;
}
.business .wisdomTraffic {
  position: absolute;
  width: 27.4667vw;
  height: 7.7333vw;
  top: 173.3333vw;
  /* right: 5.2vw; */
  /* background: #01060a;
  box-shadow: 0vw 0.2667vw 2.6667vw 0vw rgba(206, 206, 206, 0.9); */
  background-color: #01060a;
  box-shadow: 0vw 0.1333vw 1.3333vw 0vw rgba(206, 206, 206, 0.9);
  opacity: 0.42;
  z-index: 3;
  /* right: 5.3vw; */
  right: 5.5vw;
}

.business .wisdomtrafficSpan {
  position: absolute;
  display: block;
  top: 174.1333vw;
  right: 10.6667vw;
  margin: 0.8vw 0vw 0.9333vw 4vw;
  letter-spacing: 0.248vw;
  font-size: 4.2667vw;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ffffff;
  opacity: 1;
  z-index: 4;
}

.business .dottedLine {
  position: absolute;
  /* background-image: url(../assets/img/homepage_建筑智能化_mob.png); */
  background-image: url(../assets/img/智能安防1_mob.png);
  background-size: 100% 100%;
  /* width: 93.6vw; */
  width: 89vw;
  height: 100vw;
  top: 25.8667vw;
  right: 3.2vw;
  left: 3.2vw;
  margin-left: 2.3vw;
  /* border: 0.2667vw dotted #cecece; */
  z-index: 2;
}
.business .introduce {
  position: absolute;
  width: 89.3333vw;
  height: 37.6vw;
  top: 123.2vw;
  right: 5.3333vw;
  left: 5.3333vw;
  background-color: #ffffff;
  opacity: 0.88;
  z-index: 1;
}

.business .introduce .briefly {
  margin: 5.0667vw 8vw 0vw 5.3333vw;
  width: 76vw;
  font-size: 3.2vw;
  letter-spacing: 0.1333vw;
  color: #000000;
  text-shadow: 0vw 0.2667vw 1.3333vw rgba(206, 206, 206, 0.5);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  opacity: 0.58;
  line-height: 5vw;
}
.more {
  margin-top: 6.9333vw;
  margin-left: 5.3333vw;
  width: 29.3333vw;
  height: 8vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.0667vw;
  border: 0.1333vw solid #140047;
  position: relative;
}
.more span {
  float: left;
  display: block;
  padding: 2.2vw 0vw 2.4vw 4.2667vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  line-height: 3.2vw;
  font-size: 3.2vw;
  text-shadow: 0vw 0.1333vw 1.3333vw rgba(206, 206, 206, 0.5);
}

.more img {
  width: 10.6667vw;
  height: 8vw;
  position: absolute;
  left: 18.6667vw;
}
.business .traffic {
  position: absolute;
  /* background-image: url(../assets/img/homepage_智慧交通_mob.png); */
  background-image: url(../assets/img/智能交通首页封面.png);
  /* width: 93.6vw; */
  height: 100vw;
  background-size: 100% 100%;
  top: 164.5333vw;
  /* left: 3.2vw; */
  z-index: 2;

  width: 89.4vw;
  height: 100vw;
  right: 3.2vw;
  left: 3.2vw;
  margin-left: 1.8vw;
}

.business .introduce2 {
  position: absolute;
  width: 89.3333vw;
  height: 37.6vw;
  top: 262.4vw;
  right: 5.3333vw;
  left: 5.3333vw;
  background-color: #ffffff;
  opacity: 0.88;
  z-index: 1;
}
.business .introduce2 .briefly2 {
  margin: 5.0667vw 8vw 0vw 5.3333vw;
  font-size: 3.2vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-shadow: 0vw 0.1333vw 1.3333vw rgba(206, 206, 206, 0.5);
  opacity: 0.58;
  line-height: 5vw;
}
.news {
  position: relative;
  width: 100vw;
}
.news .newsbg {
  position: absolute;
  font-size: 24vw;
  letter-spacing: -1.2vw;
  color: #fafafa;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  top: 10.6667vw;
  left: 5.3333vw;
  z-index: -1;
}

.newCenter {
  display: block;
  padding: 26.6667vw 65.8667vw 2.8vw 7.0667vw;
  font-size: 6.4vw;
  font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
  font-weight: normal;
  color: #140047;
  letter-spacing: 0.2667vw;
}
.fourTitle ul li {
  display: inline-block;
  width: 24vw;
  height: 10.6667vw;
  line-height: 10.6667vw;
  text-align: center;
  float: left;
  position: relative;
}
.foutTitle ul .change i {
}
.fourTitle button {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1d1d;
  opacity: 0.3;
}
.fourTitle ul .active button {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #140047 !important;
  opacity: 1;
}
.fourTitle ul .active button i {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  position: absolute;
  width: 53px;
  height: 1.5px;
  left: 50%;
  background-color: #140047;
  margin-left: -26.5px;
  bottom: 0px;
}
.news .shownews li {
  width: 92vw;
  height: 27.4667vw;
  margin: 4.1333vw 3.8667vw 3.2vw 4vw;
  background-color: #ffffff;
  position: relative;
}
.shownews .left {
  width: 17.6vw;
  height: 100%;
  float: left;
  border-right: 1px solid #ecf0f2;
}
.shownews .right {
  width: 73.4vw;
  height: 100%;
  float: left;
}

.news .shownews {
  height: 131.7333vw;
  width: 100vw;
  position: relative;
}
.shownews .newsab {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #e9edf6;
  opacity: 0.48;
}
.news .shownews ul {
  position: absolute;
  height: 100%;
  width: 100%;
}
.news .shownews li h3 {
  position: absolute;
  width: 5.3333vw;
  height: 5.0667vw;
  top: 9.0667vw;
  left: 5.0667vw;
  font-size: 4.8vw;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 5.6vw;
  letter-spacing: 0.2667vw;
}

.news .shownews li i {
  position: absolute;
  left: 5.55vw;
  width: 2.4vw;
  height: 0.2667vw;
  top: 18.4vw;
  background-color: #ffa200;
}
.news .shownews li .yearMonth {
  position: absolute;
  display: block;
  top: 15.2vw;
  left: 0.5333vw;
  font-size: 4.2667vw;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 2.6667vw;
  letter-spacing: 0.2667vw;
  transform: scale(0.5);
  /*  -webkit-transform: scale(0.5);*/
  opacity: 0.22;
}

.news .shownews li .newTitle {
  position: absolute;
  display: block;
  width: 65.8667vw;
  height: 5.3333vw;
  line-height: 5.3333vw;
  top: 5.6vw;
  right: 4.2667vw;
  font-size: 3.7333vw;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #1d1e20;
  letter-spacing: 0.2667vw;
  overflow: hidden;
}
.news .shownews li .newContent {
  position: absolute;
  width: 65.8667vw;
  height: 8.8vw;
  top: 13.0667vw;
  right: 4.2667vw;
  bottom: 5.6vw;
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1d1d;
  line-height: 4.5333vw;
  letter-spacing: 0.2667vw;
  overflow: hidden;
  opacity: 0.44;
}
.bm {
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  background: #030e2c;
  color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 0px !important;
}
.bm span {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  display: block;
  text-align: center;
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  font-size: 3.2vw;
  opacity: 0.5;
  /* transform: scale(0.5); 
    transform-origin: 0 0; */
}
.fourTitle {
  height: 10.6667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue